import { render, staticRenderFns } from "./HoldingEnterprises.vue?vue&type=template&id=2afad8f8&"
import script from "./HoldingEnterprises.vue?vue&type=script&lang=js&"
export * from "./HoldingEnterprises.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2afad8f8')) {
      api.createRecord('2afad8f8', component.options)
    } else {
      api.reload('2afad8f8', component.options)
    }
    module.hot.accept("./HoldingEnterprises.vue?vue&type=template&id=2afad8f8&", function () {
      api.rerender('2afad8f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/operations/components/transactionality/HoldingEnterprises.vue"
export default component.exports